// components/Footer.js
import React from "react";

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      {" "}{/* Dark background, text color, generous vertical padding */}
      <div className="container mx-auto px-4">
        {" "}{/* Centered container with horizontal padding */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {" "}{/* Responsive grid layout for columns */}
          {/* Column 1: Logo and Description */}
          <div className="col-span-1 md:col-span-1 mb-8 md:mb-0">
            <img
              src="https://picsum.photos/200" // Replace with your white logo path
              alt="Logo"
              className="h-10 mb-4" // Fixed height, margin-bottom
            />
            <p className="text-gray-400 text-sm mb-4">
              {" "}{/* Lighter text, smaller font, margin-bottom */}
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </p>
            <div className="flex space-x-4">
              {" "}{/* Flex container for social icons with spacing */}
              {/* Social media icons here (ensure Font Awesome is linked in your public/index.html) */}
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
              >
                <i className="fab fa-facebook-f text-xl" />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
              >
                <i className="fab fa-twitter text-xl" />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
              >
                <i className="fab fa-instagram text-xl" />
              </a>
            </div>
          </div>
          {/* Column 2: Quick Links */}
          <div className="col-span-1 md:col-span-1 mb-8 md:mb-0">
            <h5 className="text-lg font-semibold mb-4">Quick Links</h5>
            <ul className="space-y-2">
              {" "}{/* List with vertical spacing */}
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          {/* Column 3: Resources */}
          <div className="col-span-1 md:col-span-1 mb-8 md:mb-0">
            <h5 className="text-lg font-semibold mb-4">Resources</h5>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
          {/* Column 4: Contact Us */}
          <div className="col-span-1 md:col-span-1 mb-8 md:mb-0">
            <h5 className="text-lg font-semibold mb-4">Contact Us</h5>
            <address className="not-italic text-gray-400 text-sm space-y-1">
              {" "}{/* Reset default address style, spacing */}
              <p>123 Main Street</p>
              <p>Anytown, ST 12345</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:info@example.com"
                  className="hover:text-customcolor transition duration-300"
                >
                  info@example.com
                </a>
              </p>
              <p>
                Phone:{" "}
                <a
                  href="tel:+11234567890"
                  className="hover:text-customcolor transition duration-300"
                >
                  +1 (123) 456-7890
                </a>
              </p>
            </address>
          </div>
          {/* Column 5: Explore */}
          <div className="col-span-1 md:col-span-1">
            <h5 className="text-lg font-semibold mb-4">Explore</h5>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Partnerships
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-customcolor transition duration-300 text-sm"
                >
                  Press
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr className="my-8 border-gray-700" />{" "}
        {/* Separator with margin and custom color */}
        {/* Copyright Section */}
        <div className="text-center text-gray-400 text-sm">
          &copy; {new Date().getFullYear()} Your Company. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
